import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const BackHealthIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M10.47 7.61a2 2 0 1 0-2 2 2 2 0 0 0 2-2ZM15 7.05a13 13 0 0 0-6.85-5 1 1 0 0 0-1.25.66A1 1 0 0 0 7.57 4a10.87 10.87 0 0 1 5.74 4.16l-4 2.54a4 4 0 0 0 .84 7h.11a1.12 1.12 0 0 0 .31.05 1 1 0 0 0 1-1 1 1 0 0 0-.63-.92 2 2 0 0 1-.49-3.53 2.19 2.19 0 0 1 .51-.25 7 7 0 0 1 .57 2.95v7a1 1 0 0 0 2 0v-5h2v5a1 1 0 1 0 2 0v-7A13.89 13.89 0 0 0 15 7.05Z" />
    </IconBase>
  );
};

export default BackHealthIcon;
